import { Stack } from 'expo-router';

export default function PersonalChatLayout() {
  return (
    <Stack screenOptions={{ headerTintColor: '#C8102E' }}>
      <Stack.Screen name="index" options={{ title: 'Chat' }} />
      <Stack.Screen name="[conversationId]" options={{ title: '' }} />
    </Stack>
  );
}
